import Dialog from './Dialog';

const EnterErrorDialog = ({
  onClose,
  message,
}: {
  onClose: () => void;
  message?: string;
}) => {
  return (
    <Dialog
      title="Error occurred"
      onClose={() => onClose()}
      showFooter={false}
      error
    >
      <div style={{ textAlign: 'center' }}>
        {message ? message : 'An error occurred, please try again later'}
      </div>
    </Dialog>
  );
};

export default EnterErrorDialog;
